import {CONTINUOUS_ACHIEVE_TYPE} from "./ContinuousAchieveDetector";
import {settingMap} from "../../data/Constants";

export class AchievedRecord {
  constructor({type, goal, continuous, achievedTime}) {
    this.type = type
    this.goal = goal
    this.continuous = continuous
    this.achievedTime = achievedTime
  }

  toString() {
    const isContinuous = !!CONTINUOUS_ACHIEVE_TYPE[this.type]
    return isContinuous ? this.toStringOfContinuous() : this.toStringOfCount()
  }

  toStringOfContinuous() {
    let str = ''
    if (this.continuous === 1) {
      str += `初めて`
    } else {
      str += `${this.continuous}日連続で`
    }
    const setting = settingMap[this.getKey()]
    if (this.goal > 0) {
      if (this.type === 'time') str += `${this.goal/60}分`
      else str += `${this.goal}${setting.unit}`
    }
    switch (this.type) {
      case 'time': str += '運動した';break
      default:
        str += `${setting.title}した`
        break
    }
    return str
  }

  toStringOfCount() {
    let str = ''
    switch (this.type) {
      case 'jogging-dist': str += `合計${this.goal/1000}kmジョギングした`;break
      default:
        const setting = settingMap[this.getKey()]
        return `合計${this.goal}${setting.unit}${setting.title}した`
    }
    return str
  }

  getKey() {
    const l = this.type.split('-')
    return l.slice(0, l.length - 1).join('-')
  }
}



// WEBPACK FOOTER //
// ./src/components/common/achievement/AchievedRecord.js